import { isNumeric } from 'utils/isNumeric';

type UidType = 'user' | 'contact' | 'email' | 'group' | 'deactivated';

/**
 * Returns object with type of record and ID/plain email.
 *  1. @contact - means that the record is a created contact.
 *  2. @user - means that the record is a project user.
 *  3. @group - means that the record is a group of contacts/contacts+users.
 *  4. @email - plain email.
 *  5. @deactivated - deactivated user.
 * @param uid - string that is received from back-end that represents ID of record or a simple email.
 */
export const extractIdFromUId = (uid: string): { type: UidType, value: number | string } => {
    let type, value;
    // Typify provided string
    if (uid.startsWith('@user')) {
        type = 'user';
    } else if (uid.startsWith('@deactivated')) {
        type = 'deactivated';
    } else if (uid.startsWith('@contact')) {
        type = 'contact';
    } else if (uid.startsWith('@group')) {
        type = 'group';
    } else {
        type = 'email';
    }
    // Extract and validate string ID
    if (type !== 'email') {
        const id = uid.slice(`@${type}`.length);
        if (isNumeric(id)) {
            value = parseFloat(id);
        } else {
            console.warn(`Failed to extract ID from "${uid}"`);
            type = 'email';
            value = uid;
        }
    } else { // if it's email - leave as is
        value = uid;
    }
    return { type, value };
};